import { coinManagementConstant } from "../_constants/coinManagement.constant";

export default function coinManagement(state = {}, action) {
  switch (action.type) {
    //get
    case coinManagementConstant.GET_COIN_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case coinManagementConstant.GET_COIN_LIST_SUCCESS:
      return {
        ...state,

        loading: false,
        getCoinList: action?.coin,
      };
    case coinManagementConstant.GET_COIN_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };





    case coinManagementConstant.GET_ALL_FIAT_CURRENCY_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case coinManagementConstant.GET_ALL_FIAT_CURRENCY_LIST_SUCCESS:
      return {
        ...state,

        loading: false,
        getAllFiatCurrency: action?.coin?.data?.list,
      };
    case coinManagementConstant.GET_ALL_FIAT_CURRENCY_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };








    //add
    case coinManagementConstant.CREATE_COIN_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case coinManagementConstant.CREATE_COIN_LIST_SUCCESS:
      return {
        ...state,

        loading: false,
        error: action?.user,
      };
    case coinManagementConstant.CREATE_COIN_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    //  update
    case coinManagementConstant.UPDATE_COIN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case coinManagementConstant.UPDATE_COIN_SUCCESS:
      return {
        ...state,

        loading: false,
        error: action?.user,
      };
    case coinManagementConstant.UPDATE_COIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };


    //update status
    case coinManagementConstant.UPDATE_COIN_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case coinManagementConstant.UPDATE_COIN_STATUS_SUCCESS:
      return {
        ...state,

        loading: false,
        error: action?.user,
      };
    case coinManagementConstant.UPDATE_COIN_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };


    //delete
    case coinManagementConstant.DELETE_COIN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case coinManagementConstant.DELETE_COIN_SUCCESS:
      return {
        ...state,

        loading: false,
      };
    case coinManagementConstant.DELETE_COIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };


    case coinManagementConstant.CREATE_APIKEY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case coinManagementConstant.CREATE_APIKEY_SUCCESS:
      return {
        ...state,

        loading: false,
        error: action?.user,
      };
    case coinManagementConstant.CREATE_APIKEY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case coinManagementConstant.GET_HISTORY_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case coinManagementConstant.GET_HISTORY_LIST_SUCCESS:
      return {
        ...state,

        loading: false,
        getHistoryList: action?.coin,
      };
    case coinManagementConstant.GET_HISTORY_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case coinManagementConstant.GET_PKRD_HISTORY_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case coinManagementConstant.GET_PKRD_HISTORY_LIST_SUCCESS:
      return {
        ...state,

        loading: false,
        getPkrdHistoryList: action?.coin,
      };
    case coinManagementConstant.GET_PKRD_HISTORY_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
}
